import React from 'react';
import Sidebar from './Sidebar';
import Breadcrumb, { BreadcrumbItem } from './Breadcrumb';
import { cn } from '../lib/utils';

interface LayoutProps {
  children: React.ReactNode;
  showBreadcrumb?: boolean;
  breadcrumbItems?: BreadcrumbItem[];
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl' | '7xl' | 'full';
  className?: string;
  defaultCollapsed?: boolean;
}

const maxWidthClasses = {
  sm: 'max-w-screen-sm',
  md: 'max-w-screen-md',
  lg: 'max-w-screen-lg',
  xl: 'max-w-screen-xl',
  '2xl': 'max-w-screen-2xl',
  '3xl': 'max-w-[1600px]',
  '4xl': 'max-w-[1800px]',
  '5xl': 'max-w-[2000px]',
  '6xl': 'max-w-[2200px]',
  '7xl': 'max-w-[2400px]',
  full: 'max-w-full',
};

const Layout: React.FC<LayoutProps> = ({
  children,
  showBreadcrumb = true,
  breadcrumbItems,
  maxWidth = '3xl',
  className,
  defaultCollapsed = false
}) => {
  return (
    <div className="h-screen bg-gray-50/50 flex flex-col md:flex-row overflow-hidden">
      <Sidebar defaultCollapsed={defaultCollapsed} />
      <main
        id="main-content"
        className="flex-1 min-w-0 overflow-auto" // min-w-0 prevents flex child from overflowing, overflow-auto enables independent scrolling
      >
        <div className={cn(
          "mx-auto w-full px-4 py-4 md:px-8 md:py-8 transition-all duration-200 ease-in-out",
          maxWidthClasses[maxWidth],
          className
        )}>
           {showBreadcrumb && (
            <div className="mb-6">
              <Breadcrumb items={breadcrumbItems} />
            </div>
           )}
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
